import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    listUsuarios: [],
    rolesUsuarios: [],
  },
  mutations: {
    getUsuarios(state, datos) {
      state.listUsuarios = datos;
    },
    insertUsuarios(state, datos) {
      state.listUsuarios.push(datos);
    },
    deleteUsuarios(state, datos) {
      state.listUsuarios.splice(state.listUsuarios.findIndex((element) => element.ID === datos), 1);
    },
    destroyUserStore(state) {
      state.listUsuarios = [];
    },
    updateUsuarios(state, datos) {
      state.listUsuarios.splice(state.listUsuarios.findIndex((element) => element.ID === datos.ID), 1, datos);
    },
    getRoles(state, datos) {
      state.rolesUsuarios = datos;
    },

  },
  actions: {
    async getRoles({
      commit,
    }) {
      try {
        const res = await api.getRoles();
        // console.log(object);
        if (res.data.DATOS) {
          console.log(res.data.DATOS);
          commit('getRoles', res.data.DATOS);
          return true;
        } return false;
      } catch (error) {
        console.log(error);
      }
    },
    async getUsuarios({
      commit,
    }) {
      try {
        const res = await api.getUsuarios();
        // console.log(object);
        if (res.data.DATOS) {
          commit('getUsuarios', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },
    async destroyUserStore({
      commit,
    }) {
      commit('destroyUserStore');
    },
    async insertUsuarios({
      commit,
    }, user) {
      try {
        const res = await api.insertUsuarios(user);
        if (res.data.INFO.cod === '200') {
          commit('insertUsuarios', res.data.user);
          return [true, res.data.INFO];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },
    async updateUsuarios({
      commit,
    }, user) {
      try {
        const res = await api.updateUsuarios(user);
        if (res.data.INFO.cod === '200') {
          commit('updateUsuarios', res.data.user);
          return [true, res.data.INFO];
        }
        return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },
    async deleteUsuarios({
      commit,
    }, user) {
      try {
        const res = await api.deleteUsuarios(user);
        if (res.data.INFO.cod === '200') {
          commit('deleteUsuarios', user);
          return [true, res.data.INFO];
        }
        return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },
  },
};
